import React, { Fragment, useState, useEffect } from "react";
import { Modal, Form, Button, Row, Col } from "react-bootstrap";
import { useDropzone } from 'react-dropzone';
import Icon from 'react-icons-kit';
import { close } from 'react-icons-kit/fa';
import { connect } from 'react-redux';
import { STORE_INFO_IMPORT_CUSTOMER_UPDATE_REQUEST } from "../../../../../_utils/constants/admin/StoreInfo";

const ImportCustomerUpdate = ({
	auth: { auth },
	StoreInfo: { customerUpdateImportLoading, isCustomerUpdateImported, customerUpdateSuccessRecords, customerUpdateDuplicateRecords },
	importUpdateModalOpen,
	showImportUpdateModal,
	hideImportUpdateModal,
	importUpdateStoreId,
	submitImportCustomerUpdate
}) => {

	// states declarations
	const [myFiles, setMyFiles] = useState([]);

	// dropzone initialization function
	const { getRootProps, getInputProps, inputRef } = useDropzone({
		accept: {
			'text/csv': ['.csv'],
			'application/vnd': ['.xls', '.xlsx']
		},
		onDrop: acceptedFiles => {
			acceptedFiles.map(file => setMyFiles(myFiles => [...myFiles, Object.assign(file)]))
		}
	});

	// function to remove a file from uploaded file list
	const removeFile = (file) => () => {
		const newFiles = [...myFiles];
		newFiles.splice(newFiles.indexOf(file), 1);
		setMyFiles(newFiles);
	}

	// function to remove all uploaded files
	const removeAll = () => {
		setMyFiles([]);
		inputRef.current.value = '';
	}

	// function called on file uploads
	const files = myFiles.map(file => (
		<li key={file.path} className="mb-2">
			{file.path} <Icon role='button' className="float-end" onClick={removeFile(file)} size={16} icon={close} />
		</li>
	));

	const handleImportCustomerUpdateSubmit = (e) => {
		e.preventDefault();
		var formdata = new FormData();
		formdata.append("StoreId", importUpdateStoreId);
		formdata.append("UserId", auth[0].userId);
		myFiles.map((item) => (
			formdata.append("files", item, item.name)
		))
		submitImportCustomerUpdate({
			'token': auth[0].token,
			'data': formdata
		});
	}
	useEffect(() => {
		if (isCustomerUpdateImported === true) {
			removeAll();
		}
	}, [isCustomerUpdateImported])

	return (
		<Fragment>
			<Button className="btn-sm" variant="primary" onClick={showImportUpdateModal}>
				Update true owner &amp; Mgmt Co.
			</Button>
			<Modal show={importUpdateModalOpen} size="md">
				<Form onSubmit={handleImportCustomerUpdateSubmit}>
					<Modal.Header>
						<Modal.Title>Update true owner &amp; Mgmt Co.</Modal.Title>
					</Modal.Header>
					<Modal.Body>
						<section className="container">
							<div {...getRootProps({ className: 'dropzone-style' })}>
								<input {...getInputProps()} />
								<p>Drag &apos;n&apos; drop some files here, or click to select files</p>
								<em>(Only *.xls, *.xlsx and *.csv files will be accepted)</em>
							</div>
							{files.length > 0 && (
								<div>
									<aside className="mt-3">
										<Row>
											<Col xs="8">
												<h5>Uploaded Files</h5>
											</Col>
											<Col xs="4">
												<div role="button" className="float-end" onClick={removeAll}>Remove All</div>
											</Col>
										</Row>
										<ul>{files}</ul>
									</aside>
								</div>
							)}
							{(customerUpdateSuccessRecords !== "" && customerUpdateDuplicateRecords !== "") ? (
								<aside className="mt-3">
									<Row>
										<Col>
											<h6>Data imported successfully - {customerUpdateSuccessRecords}</h6>
										</Col>
									</Row>
									<Row>
										<Col>
											<h6>Duplicate data found - {customerUpdateDuplicateRecords}</h6>
										</Col>
									</Row>
									<ul>{files}</ul>
								</aside>
							) : ""}
						</section>
					</Modal.Body>
					<Modal.Footer>
						<Button variant="secondary" onClick={hideImportUpdateModal}>
							Close
						</Button>
						{customerUpdateImportLoading ? (
							<Button variant="primary" type="button">
								<div className="spinner-border"></div>
							</Button>
						) : (
							<Button variant="primary" type="submit">
								Save
							</Button>
						)}
					</Modal.Footer>
				</Form>
			</Modal>
		</Fragment>
	)
};

const mapStateToProps = ({ auth, StoreInfo }) => {
	return {
		auth,
		StoreInfo
	};
};

const mapDispatchToProps = (dispatch) => {
	return {
		submitImportCustomerUpdate: (data) => dispatch({ type: STORE_INFO_IMPORT_CUSTOMER_UPDATE_REQUEST, data })
	};
};

export default connect(mapStateToProps, mapDispatchToProps)(ImportCustomerUpdate);
